import { Message } from 'sugar-design';

import { getI18n } from '@/utils/i18n';

const i18n = getI18n();

/**
 * Add loading toast.
 *
 * @param  {String} message - Loading toast message.
 * @param  {String} id - Id of the toast, used for replacing it with other message.
 * @param  {Object} option {
 *                    delay: toast delay ms
 *                  }
 */
export function loadingToast(message = i18n.t`操作中…`) {
  return () => Message.sendMessage({ type: 'info', content: message });
}

/**
 * Add success toast.
 *
 * @param  {String} message - Loading toast message.
 * @param  {String} id - Id of the toast, used for replacing it with other message.
 * @param  {Object} option {
 *                    delay: toast delay ms
 *                  }
 */
export function successToast(message = i18n.t`操作成功`) {
  return () => Message.sendMessage({ content: message, type: 'success' });
}

/**
 * Add error toast.
 *
 * @param  {String} message - Loading toast message.
 * @param  {String} id - Id of the toast, used for replacing it with other message.
 * @param  {Object} option {
 *                    delay: toast delay ms
 *                  }
 */
export function errorToast(message = i18n.t`操作失败`) {
  return () => Message.sendMessage({ type: 'error', content: message });
}
